import './UserPanel.scss'
import { useMemo, useCallback } from 'react'
import { useNavigate } from "react-router-dom"
import { useAuth } from '../../../../features/auth/context/authContext'
import { useScreenSize } from '../../../hook/useScreenSize'
import { useTranslation } from 'react-i18next'
import { DropDownButton } from 'devextreme-react'
import { ProfileButtonTemplate } from './ProfileButtonTemplate'

export const UserPanel: React.FC = () => {
    const { signOut, user, userProfilePicture } = useAuth()
    const navigate = useNavigate()
    const { isXSmall } = useScreenSize()
    const { t } = useTranslation()

    const navigateToProfile = useCallback(() => {
        navigate("/profile");
    }, [navigate]);

    const menuItems = useMemo(() => ([
        {
            text: t('Profile'),
            icon: 'user',
            onClick: () => {
                navigateToProfile()
            }
        },
        {
            text: t('Logout'),
            icon: 'runner',
            onClick: () => {
                signOut()
            }
        }
    ]), [navigateToProfile, signOut, t])

    return (
        <DropDownButton
            className={`dropdown-button-background ${isXSmall ? "mobile" : ""}`}
            onButtonClick={navigateToProfile}
            splitButton
            useSelectMode={false}
            dropDownOptions={{
                fullScreen: false,
                showCloseButton: false,
                showTitle: false,
                activeStateEnabled: false,
            }}
            keyExpr='text'
            displayExpr='text'
            items={menuItems}
            render={() => <ProfileButtonTemplate
                text={user?.displayName || ''}
                description={user?.administrationName}
                profilePicture={userProfilePicture}
            />}
        />
    );
}
